export const customClasses = {
  questionText: "text-left font-bold my-6 capitalize text-lg",
  helperText: "text-md text-gray-700",
  errorText: "text-red-500",
  helperTextUnderForm: "text-gray-400 mt-2 italic",
};
